import qs from 'qs';

export function getParams(url: string) {
  const [, params] = url.split('?');
  return params ? qs.parse(params) : {};
}
